<script>
	import { getContext, createEventDispatcher } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../scripts/styles'

	const globals = getContext('globals')
	export let fontsize = globals.fsS
	export let titleColor = globals.adminSelectTitle
	export let borderColor = globals.adminInputBorder
	export let titleBackground = globals.adminInputBg
	export let optionBg = globals.adminOptionBg
	export let optionHoverColor = globals.selectHover
	export let width = globals.inputWidth
	export let value = 'select'
	export let cmd = 'cmd'
	export let options = 'options'
	export let marginBottom = '0px'

	const selection = options.split(',')

	const dispatch = createEventDispatcher()

	let visible = false

	const set_visible = () => {
		visible = visible === true ? false : true
	}

	const set_title = (val) => {
		dispatch('select', {
			name: val,
			cmd: cmd,
		})
		value = val
		set_visible(false)
	}
</script>

<main use:styles={{ marginBottom }}>
	<div class="title_container" use:styles={{ titleColor, borderColor, titleBackground, width, fontsize }}>
		<div class="title">{value}</div>

		<div
			class="caretContainer"
			use:styles={{ optionBg, optionHoverColor }}
			on:click={() => set_visible(true)}
			on:keydown={() => set_visible(true)}
		>
			<div class="caret" />
		</div>
	</div>
	{#if visible}
		<div
			use:styles={{ fontsize, optionBg, optionHoverColor, width }}
			class="option_container"
			transition:slide={{ duration: 500 }}
		>
			{#each selection as sel}
				<div
					on:click={() => set_title(sel)}
					on:keydown={() => set_title(sel)}
					use:styles={{ titleColor, optionHoverColor }}
					class="option"
				>
					{sel}
				</div>
			{/each}
		</div>
	{/if}
</main>

<style>
	main {
		margin-bottom: var(--marginBottom);
	}
	.title_container {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border: 1px solid var(--borderColor);
		font-size: var(--fontsize);
		background-color: var(--titleBackground);
		color: var(--titleColor);
		height: 40px;
		width: var(--width);
	}

	.title {
		width: 90%;
		padding: 5px;
	}

	.caretContainer {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 15%;
		height: 100%;
		/* background: var(--optionBg); */
		cursor: pointer;
	}

	.caretContainer:hover {
		background-color: var(--optionHoverColor);
	}

	.caret {
		width: 0;
		height: 0;
		border-left: clamp(1px, 1vw, 10px) solid transparent;
		border-right: clamp(1px, 1vw, 10px) solid transparent;
		border-top: clamp(1px, 1vw, 10px) solid hsl(0, 0%, 80%);
	}

	.option_container {
		padding: 10px;
		background-color: var(--optionBg);
		max-height: 200px;
		overflow-y: scroll;
		overflow-x: hidden;
		font-size: calc(var(--fontsize) - 3px);
		max-width: calc(var(--width) - 15px);
	}

	.option {
		color: var(--titleColor);
		cursor: pointer;
		padding: 10px;
	}

	.option:hover {
		background: var(--optionHoverColor);
	}
</style>
